import type { WizardPath } from "./wizard-types"

import { Bot, FileText, LayoutTemplate } from "@/components/icons"
import { CATEGORY_TONES } from "@/components/ui/tone-classes"

type EntryPointCardsProps = {
  onSelect: (path: WizardPath) => void
}

const CARDS = [
  {
    path: "ai" as const,
    icon: Bot,
    title: "AI Quick Start",
    description: "Answer 3-4 questions and let AI generate a complete use case draft for you.",
    accent: "border-border hover:border-foreground hover:bg-muted/50",
    iconColor: `${CATEGORY_TONES[0]} rounded-md p-1.5`,
  },
  {
    path: "template" as const,
    icon: LayoutTemplate,
    title: "Start from Template",
    description: "Pick from 8 curated templates with realistic pre-filled values.",
    accent: "border-border hover:border-foreground hover:bg-muted/50",
    iconColor: `${CATEGORY_TONES[1]} rounded-md p-1.5`,
  },
  {
    path: "scratch" as const,
    icon: FileText,
    title: "Start from Scratch",
    description: "Open a blank fact sheet and fill in every field manually.",
    accent: "border-border hover:border-foreground hover:bg-muted/50",
    iconColor: "bg-muted text-foreground border border-foreground rounded-md p-1.5",
  },
]

export function EntryPointCards({ onSelect }: EntryPointCardsProps) {
  return (
    <div className="grid gap-3">
      {CARDS.map((card) => (
        <button
          key={card.path}
          className={`focus-visible:ring-ring flex items-start gap-4 rounded-lg border-2 p-4 text-left transition-colors focus-visible:ring-2 focus-visible:outline-none ${card.accent}`}
          type="button"
          onClick={() => onSelect(card.path)}
        >
          <div className={`mt-0.5 shrink-0 ${card.iconColor}`}>
            <card.icon className="size-6" />
          </div>
          <div>
            <div className="font-semibold">{card.title}</div>
            <div className="text-muted-foreground mt-0.5 text-sm">{card.description}</div>
          </div>
        </button>
      ))}
    </div>
  )
}
